import { createFileRoute, redirect } from '@tanstack/react-router'
// eslint-disable-next-line no-restricted-imports
import { companiesQueryOptions } from '@/features/companies/api/companies.api'
import { PageLoadingSpinner } from '@/components/PageLoadingSpinner/PageLoadingSpinner.tsx'
import { queryClient } from '@/utils/query-client.ts'

export const Route = createFileRoute('/_authenticated/')({
  beforeLoad: async ({ context }) => {
    // Fetch companies and redirect to first company's dashboard
    const companies = await queryClient.fetchQuery(
      companiesQueryOptions(context.auth.getGlobalToken())
    )

    if (!companies || companies.length === 0) {
      if (context.auth.status == 'AUTHENTICATED') {
        await context.auth.logout('SUSPENDED_ACCOUNT')
      }

      throw redirect({ to: '/login' })
    }

    const firstCompanySlug = companies[0].slug

    // Redirect to the first company's dashboard
    throw redirect({
      to: '/$companySlug/dashboard',
      params: { companySlug: firstCompanySlug }
    })
  },
  pendingComponent: () => {
    return <PageLoadingSpinner key="page-loader" title="Loading company..." />
  }
})
